var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout"},[_c('div',{staticClass:"page-header-wrapper"},[_c('PageHeader')],1),_c('router-view',{staticClass:"sub-page"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }